import { FC, ReactNode } from "react";
import { ScrollablePage } from "@web-src/modules/common/components/ScrollablePage";
import { CXWorkspaceSettingsTopbar } from "./components/CXWorkspaceSettingsTopbar/CXWorkspaceSettingsTopbar";
import { CXWorkspaceSettingsSidebar } from "./components/CXWorkspaceSettingsSidebar";

interface CXWorkspaceSettingsLayoutProps {
  children: ReactNode;
}

export const CXWorkspaceSettingsLayout: FC<CXWorkspaceSettingsLayoutProps> = ({
  children,
}) => (
  <ScrollablePage>
    <div className="flex h-full flex-col">
      <CXWorkspaceSettingsTopbar />
      <CXWorkspaceSettingsSidebar>{children}</CXWorkspaceSettingsSidebar>
    </div>
  </ScrollablePage>
);
